import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    paddingTop: "24px",
    paddingBottom: "24px",
  },
}));
